// Enumerations
import { ModalReferencesEnumeration } from 'enumerations/modal-references.enumeration';

const isCancelApplicationModal = (id: ModalReferencesEnumeration): boolean =>
  id === ModalReferencesEnumeration.CANCEL_PROCESS;

export { isCancelApplicationModal };
